import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Popover as HUIPopover } from "@headlessui/react";
import React, { useRef, useState } from "react";
import { usePopper } from "react-popper";
import { useClickAway } from "react-use";
import { Arrow, ArrowPositioner, HUIPopoverWrapper } from "./Popover.styles";
import { ContentWrapper } from "./ContentWrapper";
import { useClickInside } from "./useClickInside";
var defaultProps = {
    position: "bottom",
    triggerAction: "hover"
};
var Popover = function(param) {
    var button = param.button, position = param.position, triggerAction = param.triggerAction, children = param.children;
    var ref = useState(null), referenceElement = ref[0], setReferenceElement = ref[1];
    var ref1 = useState(null), arrowElement = ref1[0], setArrowElement = ref1[1];
    var options = {
        placement: position,
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement
                }
            }
        ],
        strategy: "absolute"
    };
    var ref2 = useState(null), popperElement = ref2[0], setPopperElement = ref2[1];
    var ref3 = usePopper(referenceElement, popperElement, options), styles = ref3.styles, attributes = ref3.attributes;
    var ref4 = useState(false), showPopover = ref4[0], setShowPopover = ref4[1];
    var onMouseEnter = function() {
        if (triggerAction === "hover") {
            setShowPopover(true);
        }
    };
    var onMouseLeave = function() {
        if (triggerAction === "hover") {
            setShowPopover(false);
        }
    };
    var onClick = function() {
        if (triggerAction === "click") {
            setShowPopover(!showPopover);
        }
    };
    var onCloseClick = function(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (referenceElement && !referenceElement.contains(event === null || event === void 0 ? void 0 : event.target)) {
            setShowPopover(false);
        }
    };
    var clickRef = useRef(null);
    useClickAway(clickRef, onCloseClick, [
        "mouseup"
    ]);
    useClickInside(clickRef, function(target) {
        var ref, ref1;
        if (target && ((ref = target.tagName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "button" || ((ref1 = target.parentElement) === null || ref1 === void 0 ? void 0 : ref1.tagName.toLowerCase()) === "button") {
            setShowPopover(false);
        }
    });
    return /*#__PURE__*/ _jsx(HUIPopoverWrapper, {
        showing: showPopover,
        position: position,
        children: /*#__PURE__*/ _jsx(HUIPopover, {
            onMouseEnter: function() {
                return onMouseEnter();
            },
            onMouseLeave: function() {
                return onMouseLeave();
            },
            children: function() {
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(HUIPopover.Button, _object_spread_props(_object_spread({}, button), {
                            ref: setReferenceElement,
                            onClick: function() {
                                return onClick();
                            }
                        })),
                        showPopover && /*#__PURE__*/ _jsxs(HUIPopover.Panel, _object_spread_props(_object_spread({
                            static: true,
                            ref: setPopperElement,
                            style: styles.popper
                        }, attributes.popper), {
                            children: [
                                /*#__PURE__*/ _jsx(ContentWrapper, {
                                    ref: clickRef,
                                    onClose: triggerAction === "click" ? onCloseClick : undefined,
                                    children: children
                                }),
                                /*#__PURE__*/ _jsx(ArrowPositioner, {
                                    ref: setArrowElement,
                                    style: styles.arrow,
                                    position: position,
                                    children: /*#__PURE__*/ _jsx(Arrow, {
                                        position: position
                                    })
                                })
                            ]
                        }))
                    ]
                });
            }
        })
    });
};
Popover.defaultProps = defaultProps;
export { Popover };
